<template>
   <div class="under-maintenance">
      <div class="bg-imageMaintenance"></div>
      <div class="overlay-content">
         <div class="transparent-box">
            <i class="fa-regular fa-triangle-exclamation"></i>
            <h3 class="font-weight-bold text-center">Atenção...</h3>
            <p class="text-center">Estamos em manutenção para melhor atendê-lo(a). Caso haja dúvidas entre em contato!
            </p>
         </div>
         <b-button class="btn__sistemacpv" @click="goBack" variant="transparent"><i
               class="fa-solid fa-arrow-left-to-bracket"></i> Voltar</b-button>
      </div>
   </div>
</template>

<script>
export default {
   name: 'UnderMaintenance',
   methods: {
      goBack() {
         return window.history.back();
      }
   }
}
</script>

<style lang="scss" scoped>
.under-maintenance {
   position: relative;
   width: 100%;
   height: 100vh;
   overflow: hidden;
}

.bg-imageMaintenance {
   background: url("../../assets/images/under-maintenance.png");
   background-repeat: no-repeat;
   background-position: 100% 100%;
   object-fit: cover;
   padding: 15rem 0rem;
   width: 100%;
   height: 100%;
   position: absolute;
   top: 0;
   left: 0;
   filter: blur(4px);
   z-index: 1;
}

.overlay-content {
   position: absolute;
   top: 0;
   left: 0;
   width: 100%;
   height: 100%;
   z-index: 2;
   display: flex;
   justify-content: center;
   align-items: center;
   flex-direction: column;
}

.transparent-box {
   background-color: rgba($color: #FFFFFF, $alpha: 0.7);
   width: 600px;
   height: 300px;
   border-radius: 12px;
   box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);

   display: inline-flex;
   flex-direction: column;
   justify-content: center;
   align-items: center;
   padding: 0 16px;

   i {
      font-size: 50px;
      color: #E98B24;
   }

   h3 {
      margin: 15px 0;
      font-size: 32px;
   }

   p {
      font-size: 18px;
   }

}

.btn__sistemacpv {
   display: inline-flex;
   min-width: auto;
   min-height: auto;

   margin: 20px auto 0;
   padding: 8px 16px;

   gap: 6px;

   background-color: #e98b24;
   border: 1px solid #e98b24;
   border-radius: 5px;

   display: flex;
   align-items: center;

   font-size: 14px;
   line-height: 20px;

   color: #140a1d;

   .icon {
      width: 18px;
      height: 18px;

      display: flex;
      align-items: center;

      i {
         font-size: 16px;
         line-height: 22px;
      }
   }

   span {
      color: #140a1d;
      font-size: 16px;
      line-height: 22px;
      font-weight: 600;
   }

   &:hover {
      background-color: #d27d20;
      transition: all 0.3s ease-in-out;
      border: 1px solid #d27d20;
      color: #140a1d;
   }
}
</style>